module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = ../../../../../src/assets/fonts/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0
// module chunks = styles